module.exports = __webpack_public_path__ + "static/media/businessman.7c88a250.png";